export default {
    methods: {
        abrirUrlLegado(url, target){
            window.open(`${process.env.VUE_APP_PATH_ESTETICA}/${url}`, `estetica${target}`, 'width=auto, height=auto')
        }
    }
}
